import { RETRIEVAL_GUARDIAN_BOND } from "../guardianFormConfig";

function computeTrusteeAttorneyHomeAddress(guardian, value, attorney, keys) {
  return {
    ...guardian,
    is_attorney_home: value,
    [keys.address]:
      value === "No" ? attorney?.address : guardian[keys.address],
    [keys.city]: value === "No" ? attorney?.city : guardian[keys.city],
    [keys.state]: value === "No" ? attorney?.state : guardian[keys.state],
    [keys.zip]: value === "No" ? attorney?.zip_code : guardian[keys.zip],
  };
}

function computeProbateAttorneyHomeAddress(guardian, value, attorney, keys) {
  const updated = {
    ...guardian,
    is_attorney_home: value,
  };

  if (value === "No" && attorney) {
    return {
      ...updated,
      [keys.address]: attorney.address,
      [keys.city]: attorney.city,
      [keys.state]: attorney.state,
      [keys.zip]: attorney.zip_code,
    };
  }

  if (value === "Yes") {
    return {
      ...updated,
      [keys.address]: "",
      [keys.city]: "",
      [keys.state]: "",
      [keys.zip]: "",
    };
  }

  return updated;
}

function computeDefaultAttorneyHomeAddress(guardian, value, attorney, keys) {
  const updated = { ...guardian, is_attorney_home: value };
  if (value === "Yes") {
    return {
      ...updated,
      [keys.address]: "",
      [keys.city]: "",
      [keys.state]: "",
      [keys.zip]: "",
    };
  }
  if (attorney) {
    return {
      ...updated,
      [keys.address]: attorney.address,
      [keys.city]: attorney.city,
      [keys.state]: attorney.state,
      [keys.zip]: attorney.zip_code,
    };
  }
  return updated;
}

/**
 * @param {object} ctx
 */
export function createAttorneyHandlers({
  bondKind,
  keys,
  data,
  updateData,
  attorneys,
  updateGuardianAt,
}) {
  const handleAttorneyHomeAddressChange = (index, value) => {
    const updatedGuardians = [...data.guardians];
    const guardian = updatedGuardians[index];
    const attorney = attorneys.find((a) => a.value === guardian.attorney);

    if (bondKind === RETRIEVAL_GUARDIAN_BOND.trustee) {
      updatedGuardians[index] = computeTrusteeAttorneyHomeAddress(
        guardian,
        value,
        attorney,
        keys
      );
    } else if (bondKind === RETRIEVAL_GUARDIAN_BOND.probate) {
      updatedGuardians[index] = computeProbateAttorneyHomeAddress(
        guardian,
        value,
        attorney,
        keys
      );
    } else {
      updatedGuardians[index] = computeDefaultAttorneyHomeAddress(
        guardian,
        value,
        attorney,
        keys
      );
    }

    updateData({ ...data, guardians: updatedGuardians });
  };

  const handleAttorneySelection = (index, attorney) => {
    if (bondKind === RETRIEVAL_GUARDIAN_BOND.guardianship) {
      if (attorney) {
        const updatedGuardians = [...data.guardians];
        const selectedAttorney = attorneys.find(
          (a) => a.value === attorney.value
        );
        if (selectedAttorney) {
          updatedGuardians[index] = {
            ...updatedGuardians[index],
            [keys.name]: selectedAttorney.label,
            [keys.address]: selectedAttorney.address,
            [keys.city]: selectedAttorney.city,
            [keys.state]: selectedAttorney.state,
            [keys.zip]: selectedAttorney.zip_code,
            is_attorney: "Yes",
            is_attorney_home: "No",
            [keys.occupation]: selectedAttorney.position,
            [keys.relationship]: "Attorney of Record",
            [keys.citizenship]: "USA",
            country: "USA",
            attorney: selectedAttorney.value,
            showAttorneyForm: false,
          };
        }
        updateData({ ...data, guardians: updatedGuardians });
      } else {
        const updatedGuardians = [...data.guardians];
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          is_attorney: "No",
          is_attorney_home: "No",
          attorney: null,
          [keys.name]: "",
          [keys.address]: "",
          [keys.city]: "",
          [keys.state]: "",
          [keys.zip]: "",
          [keys.occupation]: "",
          [keys.relationship]: "",
        };
        updateData({ ...data, guardians: updatedGuardians });
      }
      return;
    }

    if (attorney) {
      const updatedGuardians = [...data.guardians];
      const base = {
        ...updatedGuardians[index],
        [keys.name]: attorney.label,
        [keys.address]: attorney.address,
        [keys.city]: attorney.city,
        [keys.state]: attorney.state,
        [keys.zip]: attorney.zip_code,
        is_attorney: "Yes",
        [keys.occupation]: attorney.position,
        [keys.relationship]: "Attorney of Record",
        [keys.citizenship]: "USA",
        [keys.country]: "USA",
        attorney: attorney.value,
        showAttorneyForm: false,
      };
      if (bondKind === RETRIEVAL_GUARDIAN_BOND.probate) {
        base.is_attorney_home = "No";
      }
      if (bondKind === RETRIEVAL_GUARDIAN_BOND.trustee) {
        base.is_attorney_home = "No";
      }
      updatedGuardians[index] = base;
      updateData({ ...data, guardians: updatedGuardians });
    } else if (bondKind === RETRIEVAL_GUARDIAN_BOND.trustee) {
      const updatedGuardians = [...data.guardians];
      updatedGuardians[index] = {
        ...updatedGuardians[index],
        [keys.name]: "",
        [keys.address]: "",
        [keys.city]: "",
        [keys.state]: "",
        [keys.zip]: "",
        is_attorney: "No",
        [keys.occupation]: "",
        [keys.relationship]: "",
        attorney: null,
        showAttorneyForm: false,
        is_attorney_home: "No",
      };
      updateData({ ...data, guardians: updatedGuardians });
    }
  };

  const handleAttorneyChange = (index, value, guardians) => {
    updateGuardianAt(
      index,
      {
        is_attorney: value,
        attorney: null,
        showAttorneyForm: false,
      },
      guardians
    );
  };

  return {
    handleAttorneyHomeAddressChange,
    handleAttorneySelection,
    handleAttorneyChange,
  };
}
